import $ from 'jquery';

const $container = $( 'body' );

if ( $container.length ) {
	$container.on( 'click', '.social-share__cta', function() {
		const $self = $( this );
		const $list = $self.next();

		if ( $list.hasClass( 'is-opened' ) ) {
			$list.removeClass( 'is-opened' );
		} else {
			$list.addClass( 'is-opened' );
		}
	} );
}